//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue"; // import AudioVisual from 'vue-audio-visual'

import { Message } from "element-ui";
export default {
  // name: 'preparing-courseware',
  data: function data() {
    return {
      faceTeach: {
        Id: "",
        ClassId: ""
      },
      pptImages: [],
      imgurl: "",
      images: [],
      options: {
        inline: true,
        button: false,
        navbar: false,
        toolbar: false,
        title: false
      },
      nameActive: 0,
      dialogVisible: false,
      changestate: false,
      ishideen: true,
      docType: 0,
      type: 0,
      isheight: 0,
      offeceUrl: "",
      pptpageindex: 1,
      currentPageIndex: 1,
      diloagslt: false,
      faceTeachList: [],
      dialogVisibleFaceTeach: false,
      facePagination: {
        totalCount: 10,
        pageSize: 6,
        pageIndex: 1
      },
      faceTeachId: "",
      classList: [],
      faceClassId: "",
      faceName: "",
      fileSourceId: "",
      route: 0,
      pinchImg: null
    };
  },
  props: {
    fileList: {
      type: Array,
      defaut: []
    },
    bottommenu: {
      type: Boolean,
      default: true
    },
    faceId: {
      type: String,
      default: ""
    },
    courseId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    },
    sourceId: {
      type: String,
      default: ""
    },
    savesession: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    viewer: function viewer() {
      return this.$refs.viewer && this.$refs.viewer.$viewer;
    }
  },
  created: function created() {
    console.log(this.fileList);
    this.fileSourceId = this.sourceId;
    this.previewImage(); // this.scrollwidth();
  },
  mounted: function mounted() {
    var _this = this;

    //课件的页面事件
    window.addEventListener("message", function (e) {
      if (typeof e.data == "string") {
        var data = JSON.parse(e.data).payload;

        if (data >= 0) {
          _this.currentPageIndex = data + 1;
          _this.nameActive = data;
        }
      }
    });
  },
  methods: {
    pinch: function pinch(evt) {
      debugger;
      this.pinchImg = document.getElementById("pinchImg");
      Transform(this.pinchImg);
      var initScale = 1;
      this.pinchImg.scaleX = this.pinchImg.scaleY = initScale * evt.zoom;
    },
    pressMove: function pressMove(evt) {
      this.pinchImg = document.getElementById("pinchImg");
      Transform(this.pinchImg);
      this.pinchImg.translateX += evt.deltaX;
      this.pinchImg.translateY += evt.deltaY;
      evt.preventDefault();
    },
    fangda: function fangda() {
      this.viewer.zoom(1);
    },
    suoxiao: function suoxiao() {
      this.viewer.zoom(-1);
    },
    rotate: function rotate() {
      this.viewer.rotate(90);
    },
    nextFile: function nextFile() {
      var index = this.fileList.indexOf(this.fileSourceId);

      if (this.fileList.length > index + 1) {
        index += 1;
        this.fileSourceId = this.fileList[index];
        this.pptImages = [];
        this.previewImage();
      }
    },
    lastFile: function lastFile() {
      var index = this.fileList.indexOf(this.fileSourceId);

      if (0 < index) {
        index -= 1;
        this.fileSourceId = this.fileList[index];
        this.pptImages = [];
        this.previewImage();
      }
    },
    handleSizeChangePaper: function handleSizeChangePaper(pageSize) {
      this.facePagination.pageSize = pageSize;
      this.goToTeach();
    },
    onPageChangePaper: function onPageChangePaper(pageIndex) {
      this.facePagination.pageIndex = pageIndex;
      this.goToTeach();
    },
    goToTeach: function goToTeach() {
      var _this2 = this;

      getFaceTeachList(this.courseId, this.faceName, this.faceClassId, this.facePagination.pageSize, this.facePagination.pageIndex).then(function (res) {
        if (res.code < 0) {
          _this2.$message(res.msg);
        } else {
          _this2.faceTeachList = res.faceTachList;
          _this2.dialogVisibleFaceTeach = true;
          _this2.facePagination.totalCount = res.pagination.totalCount;
          _this2.facePagination.pageSize = res.pagination.pageSize;
          _this2.facePagination.pageIndex = res.pagination.pageIndex;
        }
      });
    },
    goRouter: function goRouter() {
      var _this3 = this;

      AddSource(this.sourceId, this.faceTeach.Id, this.faceTeach.ClassId, this.courseId).then(function (res) {
        if (res.code > 0) {
          _this3.previewStartFaceImage(res.Id, res.DocUrl, res.DocExtension);
        } else {
          Message.warning("请选择授课");
        }
      });
    },
    previewStartFaceImage: function previewStartFaceImage(Id, url, type) {
      var _this4 = this;

      if (type == ".zip" || type == ".rar" || type == "7z") {
        this.$message("压缩包不支持预览");
      } else {
        this.$http.post("/api/XOrg/TextBookSourceInfo/getNewCourseWareInfo", {
          coursewareid: this.sourceId
        }).then(function (rst) {
          console.log(rst);

          if (rst.status == -1) {
            Message.warning("文件转换失败不能预览");
          } else if (rst.status == -2) {
            Message.warning("文件正在转换请稍后预览");
          } else if (rst.status == 1) {
            _this4.sourceUrl = {
              id: Id,
              url: rst.docPriviewUrl,
              type: type,
              docName: rst.docName,
              docType: rst.docType
            };

            _this4.RouterPreviewResources(url, true);
          }
        });
      }
    },
    RouterPreviewResources: function RouterPreviewResources(url, savesession) {
      if (sessionStorage.getItem("sourceId") != null) {
        this.sourceUrl.id = sessionStorage.getItem("sourceId");
      }

      this.$router.push({
        name: "PreviewResources",
        params: {
          courseId: this.courseId,
          classId: this.faceTeach.ClassId,
          faceId: this.faceTeach.Id,
          sourceId: this.fileSourceId,
          url: url,
          savesession: savesession
        }
      });
    },
    slt: function slt() {
      this.diloagslt = !this.diloagslt;
    },
    back: function back() {
      this.$emit("dialogVisiblePreviewResources", false);
    },
    gotopage: function gotopage(pageindex) {
      var jsonObj = {
        type: "Goto",
        payload: pageindex
      };
      var msg = JSON.stringify(jsonObj);
      document.getElementById("pptiframe").contentWindow.postMessage(msg, "*");
    },
    lastimg: function lastimg() {
      if (this.nameActive > 0 && this.docType != 6) {
        this.nameActive = parseInt(this.nameActive) - 1;
        this.imgurl = this.pptImages[this.nameActive];
        this.images = [this.imgurl];
        this.pptpageindex = this.pptpageindex - 1;
      }

      if (this.docType == 6 && this.currentPageIndex > 1) {
        this.preAnim();
      }

      debugger;
      var content = "#content" + this.nameActive;
      $(".PreviewRight-top").prop("scrollLeft", $(content).position().left - $(".PreviewRight-top").width() / 2 + 140);
    },
    nextimg: function nextimg() {
      if (this.nameActive < this.pptImages.length - 1 && this.docType != 6) {
        this.nameActive = parseInt(this.nameActive) + 1;
        this.imgurl = this.pptImages[this.nameActive];
        this.images = [this.imgurl];
        this.pptpageindex = this.pptpageindex + 1;
      }

      if (this.docType == 6 && this.currentPageIndex < this.pptImages.length) {
        this.nextAnim();
      }

      debugger;
      var content = "#content" + this.nameActive;
      $(".PreviewRight-top").prop("scrollLeft", $(content).position().left - $(".PreviewRight-top").width() / 2 + 140);
    },
    preAnim: function preAnim() {
      var jsonObj = {
        type: "PrevSlide"
      };
      var msg = JSON.stringify(jsonObj);
      document.getElementById("pptiframe").contentWindow.postMessage(msg, "*");

      if (this.pptpageindex > 1 && this.docType != 6) {
        debugger;
        this.pptpageindex = this.pptpageindex - 1;
      } else if (this.docType != 6) {
        this.pptpageindex = 1;
      }
    },
    nextAnim: function nextAnim() {
      var jsonObj = {
        type: "NextSlide"
      };
      var msg = JSON.stringify(jsonObj);
      document.getElementById("pptiframe").contentWindow.postMessage(msg, "*");

      if (this.pptpageindex < this.pptImages.length && this.docType != 6) {
        ddebugger;
        this.pptpageindex = this.pptpageindex + 1;
      } else if (this.docType != 6) {
        this.pptpageindex = this.pptImages.length;
      }
    },
    exitblowup: function exitblowup() {
      this.changestate = false;
      this.ishideen = true;
    },
    onchangestate: function onchangestate() {
      this.changestate = true;
      this.ishideen = false;
    },
    onchangelook: function onchangelook() {
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.dialogVisibleFaceTeach = false;
    },
    isimg: function isimg(val, index) {
      if (this.docType == 6) {
        this.gotopage(index + 1);
        this.currentPageIndex = index + 1;
        this.nameActive = index;
      } else {
        this.nameActive = index;
        this.pptpageindex = index + 1;
        this.imgurl = val;
        this.images = [this.imgurl];
      }

      var content = "#content" + this.nameActive;
      $(".PreviewRight-top").prop("scrollLeft", $(content).position().left - $(".PreviewRight-top").width() / 2 + 140);
      this.dialogVisible = false;
    },
    getPictureList: function getPictureList() {
      var _this5 = this;

      var img = new Image();
      var that = this;
      this.$http.post("/api/XOrg/VideoStudy/getPictureList", {
        id: this.sourceId
      }).then(function (res) {
        if (!res.list) {
          _this5.$message("稍等文件未转换完成！");
        } else {
          for (var i = 0; i < res.list.length; i++) {
            _this5.pptImages.push(res.list[i].picpath);
          }

          _this5.imgurl = _this5.pptImages[_this5.nameActive];
          _this5.images = [_this5.imgurl];
          img.src = that.imgurl;

          img.onload = function () {
            if (img.width > img.height) {
              that.isheight = 1;
            } else {
              that.isheight = 2;
            }
          };
        }
      });
    },
    previewImage: function previewImage() {
      var _this6 = this;

      var img = new Image();
      var that = this;
      this.$http.post("/api/XOrg/TextBookSourceInfo/getNewCourseWareInfo", {
        coursewareid: this.sourceId
      }).then(function (rst) {
        if (rst.status === -1) {
          Message.warning("文件转换失败不能预览");
        } else if (rst.status === -2) {
          Message.warning("文件正在转换请稍后预览");
        } else if (rst.status === 1) {
          _this6.docType = rst.docType;
          _this6.type = rst.type;

          if (rst.docType === 2) {
            _this6.getPictureList();
          } else if (rst.docType === 6) {
            _this6.getPictureList();

            if (_this6.type == "xls" || _this6.type == "xlsx") {
              _this6.diloagslt = true;
            }

            _this6.offeceUrl = rst.offecedocurl;
          } else {
            _this6.pptImages[0] = rst.docPriviewUrl;
            _this6.imgurl = rst.docPriviewUrl;
            _this6.images = [_this6.imgurl];
            img.src = rst.docPriviewUrl;

            img.onload = function () {
              if (img.width > img.height) {
                that.isheight = 1;
              } else {
                that.isheight = 2;
              }
            };
          }
        }
      });
    }
  }
};